import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-paragraph" }
const _hoisted_2 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}

import { ref, onMounted } from "vue";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import type { IConfirmationAlert } from "@/utils/EventBus";
import { toggleModal } from "@/utils/Helper";


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmationAlert',
  setup(__props) {

const submitting = ref(false);
const title = ref("");
const message = ref("");
const confirmationButtonLabel = ref("");
const cancellationButtonLabel = ref("");
const buttonColor = ref("");

let confirmCallback: IConfirmationAlert["confirmCallback"] = () => {};
let cancelCallback: IConfirmationAlert["cancelCallback"] = () => {};

onMounted(() => {
  EventBus.$on(
    EventBusNames.SHOW_CONFIRMATION_ALERT,
    ({
      title: newTitle = "Deseja continuar",
      message: newMessage = "Tem certeza que deseja continuar?",
      confirmationButtonLabel: newConfirmationButtonLabel = "Sim",
      cancellationButtonLabel: newCancellationButtonLabel = "Não",
      buttonColor: newButtonColor = "secondary",
      confirmCallback: newConfirmCallback,
      cancelCallback: newCancelCallback,
    }: IConfirmationAlert) => {
      title.value = newTitle ?? "";
      message.value = newMessage ?? "";
      confirmationButtonLabel.value = newConfirmationButtonLabel ?? "";
      cancellationButtonLabel.value = newCancellationButtonLabel ?? "";
      buttonColor.value = newButtonColor ?? "";
      confirmCallback = newConfirmCallback;
      cancelCallback = newCancelCallback;
      toggleModal("confirm_alert_modal");
    },
  );
});

const cancelAction = () => {
  if (cancelCallback) {
    cancelCallback();
  }
  toggleModal("confirm_alert_modal");
};

const alertClosed = () => {
  cancelAction();
};

const confirmAction = async () => {
  try {
    submitting.value = true;
    await confirmCallback();
    toggleModal("confirm_alert_modal");
  } catch (error) {
    console.error(error);
  } finally {
    submitting.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createBlock(_component_ModalComponent, {
    title: title.value,
    id: "confirm_alert_modal",
    onModalClosed: alertClosed
  }, {
    body: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(message.value), 1)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        onClick: cancelAction,
        class: "btn btn-outline-primary"
      }, _toDisplayString(cancellationButtonLabel.value), 1),
      _createElementVNode("button", {
        type: "button",
        onClick: confirmAction,
        class: _normalizeClass(["btn", `btn-${buttonColor.value}`])
      }, [
        (submitting.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2))
          : _createCommentVNode("", true),
        _createElementVNode("span", null, _toDisplayString(confirmationButtonLabel.value), 1)
      ], 2)
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})